import _ from 'lodash';

const reducers = {
    filters (res) {
        res = JSON.parse(res);
        return {
            url: res.Url,
            params: _.map(res.Parametros, p =>
                ({
                    type: p.Tipo,
                    values: _.reduce(p.Valores, (res, val, key) => {
                        if (key === '$id') {
                            return res;
                        }

                        if (_.isArray(val)) {
                            _.forEach(val, v => res.push({ value: key, text: v }));
                        } else {
                            res.push({ value: key, text: val });
                        }

                        return res;
                    }, [])
                })
            )
        };
    }
};

export default reducers;



// WEBPACK FOOTER //
// ./src/scripts/api/endpoints/report/reducers.js